(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["daelivo-product-gallery"] && !Shopify.designMode) return;
  try {
    class DaelivoProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.stage = this.querySelector('[data-daelivo-gallery-stage]');
      this.slides = [...this.querySelectorAll('[data-daelivo-gallery-slide]')];
      this.thumbnailRail = this.querySelector('[data-daelivo-gallery-thumbnails]');
      this.currentOutput = this.querySelector('[data-daelivo-gallery-current]');
      this.totalOutput = this.querySelector('[data-daelivo-gallery-total]');
      this.dialog = this.querySelector('[data-daelivo-gallery-dialog]');
      this.dialogImage = this.querySelector('.daelivo-product-gallery__dialog-image');
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
      this.touchStartX = null;
      this.touchStartY = null;
      this.touchLastX = null;
      this.touchLastTime = 0;
      this.touchVelocity = 0;
      this.touchRejected = false;
      this.handleClickBound = this.handleClick.bind(this);
      this.handleKeydownBound = this.handleKeydown.bind(this);
      this.handleTouchStartBound = this.handleTouchStart.bind(this);
      this.handleTouchMoveBound = this.handleTouchMove.bind(this);
      this.handleTouchEndBound = this.handleTouchEnd.bind(this);
      this.handleTouchCancelBound = (event) => this.handleTouchEnd(event, true);
      this.handleProductSelectBound = this.handleProductSelect.bind(this);
      this.variantController = new AbortController();
      this.variantTarget = this.closest('.shopify-section, dialog');
      this.addEventListener('click', this.handleClickBound);
      this.thumbnailRail?.addEventListener('keydown', this.handleKeydownBound);
      this.stage?.addEventListener('touchstart', this.handleTouchStartBound, { passive: true });
      this.stage?.addEventListener('touchmove', this.handleTouchMoveBound, { passive: true });
      this.stage?.addEventListener('touchend', this.handleTouchEndBound, { passive: true });
      this.stage?.addEventListener('touchcancel', this.handleTouchCancelBound, { passive: true });
      this.variantTarget?.addEventListener('shopify:product:select', this.handleProductSelectBound, {
        signal: this.variantController.signal,
      });
      this.buildThumbnails();
      this.goTo(this.currentIndex, false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickBound);
      this.thumbnailRail?.removeEventListener('keydown', this.handleKeydownBound);
      this.stage?.removeEventListener('touchstart', this.handleTouchStartBound);
      this.stage?.removeEventListener('touchmove', this.handleTouchMoveBound);
      this.stage?.removeEventListener('touchend', this.handleTouchEndBound);
      this.stage?.removeEventListener('touchcancel', this.handleTouchCancelBound);
      this.variantController?.abort();
      this.initialized = false;
    }

    buildThumbnails() {
      if (!this.thumbnailRail || !this.slides.length) return;
      this.thumbnailRail.replaceChildren();
      this.slides.forEach((slide, index) => {
        slide.id ||= `${this.id}-panel-${index}`;
        slide.setAttribute('role', 'tabpanel');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'daelivo-product-gallery__thumbnail';
        button.dataset.daelivoGalleryThumbnail = '';
        button.dataset.daelivoGalleryIndex = String(index);
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', slide.id);
        button.setAttribute('aria-label', `View ${index + 1} of ${this.slides.length}`);
        button.setAttribute('aria-selected', 'false');
        const preview = slide.querySelector('img');
        if (preview) {
          const thumbnail = preview.cloneNode(true);
          thumbnail.removeAttribute('loading');
          thumbnail.removeAttribute('fetchpriority');
          if (preview.dataset.daelivoGalleryThumbnailSrc) {
            thumbnail.removeAttribute('srcset');
            thumbnail.removeAttribute('sizes');
            thumbnail.src = preview.dataset.daelivoGalleryThumbnailSrc;
          }
          thumbnail.alt = '';
          thumbnail.setAttribute('aria-hidden', 'true');
          button.append(thumbnail);
        } else if (slide.querySelector('video')) {
          const thumbnail = slide.querySelector('video').cloneNode(true);
          thumbnail.controls = false;
          thumbnail.muted = true;
          thumbnail.loop = false;
          thumbnail.preload = 'metadata';
          thumbnail.removeAttribute('aria-label');
          thumbnail.setAttribute('aria-hidden', 'true');
          button.append(thumbnail);
        }
        this.thumbnailRail.append(button);
      });
      this.thumbnailButtons = [...this.thumbnailRail.querySelectorAll('[data-daelivo-gallery-thumbnail]')];
      if (this.totalOutput) this.totalOutput.textContent = String(this.slides.length);
    }

    handleClick(event) {
      const thumbnail = event.target.closest('[data-daelivo-gallery-thumbnail]');
      if (thumbnail) {
        this.goTo(Number(thumbnail.dataset.daelivoGalleryIndex));
        return;
      }
      if (event.target.closest('[data-daelivo-gallery-prev]')) {
        this.goTo(this.currentIndex - 1);
        return;
      }
      if (event.target.closest('[data-daelivo-gallery-next]')) {
        this.goTo(this.currentIndex + 1);
        return;
      }
      const zoomTrigger = event.target.closest('[data-daelivo-gallery-zoom]');
      if (zoomTrigger) {
        this.openZoom(zoomTrigger);
        return;
      }
      if (event.target.closest('[data-daelivo-gallery-dialog-close]') || event.target === this.dialog) {
        this.closeZoom();
      }
    }

    handleKeydown(event) {
      if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let index = this.currentIndex;
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = this.slides.length - 1;
      else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') index -= 1;
      else index += 1;
      this.goTo(index);
      this.thumbnailButtons[this.currentIndex]?.focus();
    }

    handleTouchStart(event) {
      if (event.touches?.length !== 1) return;
      const touch = event.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY ?? 0;
      this.touchLastX = touch.clientX;
      this.touchLastTime = event.timeStamp;
      this.touchVelocity = 0;
      this.touchRejected = false;
      this.stage?.toggleAttribute('data-dragging', false);
      this.stage?.style.setProperty('--daelivo-gallery-drag-offset', '0px');
    }

    handleTouchMove(event) {
      if (this.touchStartX === null) return;
      const touch = event.touches?.[0];
      if (!touch) return;
      const delta = touch.clientX - this.touchStartX;
      const deltaY = (touch.clientY ?? this.touchStartY) - this.touchStartY;
      if (!this.touchRejected && Math.abs(deltaY) > Math.abs(delta) && Math.abs(deltaY) > 8) {
        this.touchRejected = true;
        this.stage?.toggleAttribute('data-dragging', false);
        this.stage?.style.setProperty('--daelivo-gallery-drag-offset', '0px');
      }
      if (this.touchRejected) return;
      const elapsed = Math.max(1, event.timeStamp - this.touchLastTime);
      this.touchVelocity = (touch.clientX - this.touchLastX) / elapsed;
      this.touchLastX = touch.clientX;
      this.touchLastTime = event.timeStamp;
      const limit = Math.max(64, (this.stage?.clientWidth || 320) * 0.34);
      const offset = Math.max(-limit, Math.min(limit, delta));
      this.stage?.toggleAttribute('data-dragging', Math.abs(delta) > 6);
      this.stage?.style.setProperty('--daelivo-gallery-drag-offset', `${offset}px`);
    }

    handleTouchEnd(event, cancelled = false) {
      if (this.touchStartX === null) return;
      const touchEndX = event.changedTouches?.[0]?.clientX ?? this.touchLastX ?? this.touchStartX;
      const delta = cancelled || this.touchRejected ? 0 : touchEndX - this.touchStartX;
      const threshold = Math.max(42, (this.stage?.clientWidth || 320) * 0.14);
      const shouldAdvance = Math.abs(delta) >= threshold || Math.abs(this.touchVelocity) >= 0.45;
      const direction = delta < 0 ? 1 : -1;
      this.touchStartX = null;
      this.touchStartY = null;
      this.touchLastX = null;
      this.touchLastTime = 0;
      this.touchVelocity = 0;
      this.touchRejected = false;

      if (shouldAdvance && delta !== 0) {
        this.goTo(this.currentIndex + direction);
        const entryOffset = (this.stage?.clientWidth || 320) * 0.16 * direction;
        this.stage?.style.setProperty('--daelivo-gallery-drag-offset', `${entryOffset}px`);
      }
      window.requestAnimationFrame(() => {
        this.stage?.toggleAttribute('data-dragging', false);
        window.requestAnimationFrame(() => {
          this.stage?.style.setProperty('--daelivo-gallery-drag-offset', '0px');
        });
      });
    }

    goTo(index, shouldScroll = true) {
      if (!this.slides.length) return;
      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.warmMedia();
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.currentIndex;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      this.thumbnailButtons?.forEach((button, buttonIndex) => {
        const active = buttonIndex === this.currentIndex;
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.toggleAttribute('aria-current', active);
        button.tabIndex = active ? 0 : -1;
      });
      if (this.currentOutput) this.currentOutput.textContent = String(this.currentIndex + 1);
      if (shouldScroll) {
        this.thumbnailButtons?.[this.currentIndex]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    warmMedia() {
      if (!this.slides.length) return;
      const indexes = new Set([
        (this.currentIndex - 1 + this.slides.length) % this.slides.length,
        this.currentIndex,
        (this.currentIndex + 1) % this.slides.length,
      ]);
      this.slides.forEach((slide, index) => {
        if (!indexes.has(index)) return;
        slide.querySelectorAll?.('img').forEach((image) => {
          image.loading = 'eager';
          image.setAttribute('fetchpriority', index === this.currentIndex ? 'high' : 'auto');
        });
      });
    }

    handleProductSelect(event) {
      if (event.target?.closest?.('product-card') || !event.promise?.then) return;
      event.promise
        .then(({ detail }) => {
          const newGallery = detail?.html?.querySelector(`#${this.id}`) || detail?.html?.querySelector('daelivo-product-gallery');
          if (newGallery) this.replaceWith(newGallery);
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[daelivo-product-gallery] Product selection failed:', error);
        });
    }

    openZoom(trigger) {
      if (!this.dialog || this.dialog.open) return;
      this.zoomTrigger = trigger;
      if (this.dialogImage && trigger.dataset.daelivoGalleryZoomSrc) {
        this.dialogImage.src = trigger.dataset.daelivoGalleryZoomSrc;
        this.dialogImage.alt = trigger.dataset.daelivoGalleryZoomAlt || '';
      }
      this.dialog.showModal();
    }

    closeZoom() {
      if (!this.dialog?.open) return;
      this.dialog.close();
      this.zoomTrigger?.focus();
      this.zoomTrigger = null;
    }
  }

  if (!customElements.get('daelivo-product-gallery')) {
    customElements.define('daelivo-product-gallery', DaelivoProductGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
